<template>
  <div class="campaign-template">

    <div class="container">
      <div class="campaign-header">
        <h1 class="page-title">สร้างเพจระดมเงินบริจาค</h1>
        <h2 class="sub-title">เพื่อร่วมบริจาคในโอกาสพิเศษของคุณหรือเพื่อนของคุณ</h2>
      </div>
    </div>

    <div class="container pd-0">
      <div class="col-md-push-1 col-md-10 col-lg-push-2 col-lg-8 pd-0">
        <progress-step :steps="['1 สร้างเพจ', '2 เข้าสู่ระบบ', '3 บริจาค']" :active="step" />
      </div>
    </div>

    <div class="container pd-0">
      <div class="col-md-push-1 col-md-10 col-lg-push-2 col-lg-8 pd-0">
        <div class="_bg-graphic">
          <div class="block shadow">
            <div class="text-center mb-20">คุณสามารถสร้างเพจระดมเงินเนื่องในโอกาสพิเศษของคุณหรือของเพื่อนได้ เพื่อส่งต่อความปรารถนาดีและร่วมให้โอกาสทางการศึกษาแก่เด็กด้อยโอกาสไปพร้อมกัน </div>
            <div class="wrapper--pageform ">

              <card
                ref="card"
                :type="form.type"
                :name="form.name"
                :date="date"
                :custom-title="form.custom_type"
                :top-image="form.top_image"
                :bottom-image="form.bottom_image"
                :avatar-image="form.avatar_image"
                :editing="editing" />
                <div class="row">
                  <div class="col-md-6 col-md-push-3">
                    <transition name="fade">
                      <div class="" v-if="showRegisterForm">
                        <page-register-form @submit="registerComplete" @cancel="cancelRegisterForm" />
                      </div>
                    </transition>
                  </div>
                </div>

              <transition name="fade">
                <div class="" v-if="!showRegisterForm">
                  <page-form v-model="form" @submit="submit" />
                </div>
              </transition>

            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import DonorInfo from '@/components/DonorInfo'
  import PageSelector from '@/components/PageSelector'
  import ProductCartAction from '@/components/ProductCartAction'
  import ProductDonateChoice from '@/components/ProductDonateChoice'
  import PageForm from './form'
  import PageCard from '@/components/PageCard'
  import PageRegisterForm from '@/components/PageRegisterForm'
  import ProgressStep from '@/components/ProgressStep'
  import Card from './card'

  export default {
    name: 'PageCreateSpecialEvent',

    components: {
      DonorInfo,
      PageSelector,
      ProductCartAction,
      ProductDonateChoice,
      PageCard,
      PageRegisterForm,
      ProgressStep,
      Card,
      PageForm
    },

    props: {
      title: { type: String, default: 'บริจาค' },
      product: { type: Object, required: true }
    },

    computed: {
      date () {
        const month = this.$const.MONTH_LIST.find(item => item.value === this.form.month)
        if (month) {
          return `${parseInt(this.form.day)} ${month.name}`
        } else {
          return ''
        }
      },

      pageTitle () {
        if (this.form.type === this.$const.SPECIAL_EVENT_TYPES.OTHER) {
          return this.form.custom_type
        } else {
          return Object.keys(this.$const.SPECIAL_EVENT_TYPES).find(key => this.$const.SPECIAL_EVENT_TYPES[key] === this.form.type)
        }
      }
    },

    data () {
      return {
        step: 1,
        form: {
          message: '',
          type: this.$const.SPECIAL_EVENT_TYPES.BIRTHDAY,
          custom_type: '',
          name: '',
          day: '',
          month: '',
          target: '',
          end_date: '',
          send_ecard: false,
          send_ecard_emails: [''],
          top_image: '',
          bottom_image: '',
          avatar_image: ''
        },
        editing: true,
        attributes: {},
        showRegisterForm: false
      }
    },

    methods: {
      getPayload () {
        const data = JSON.parse(JSON.stringify(this.form))
        data.send_ecard_emails = data.send_ecard_emails.filter(item => item)
        data.body = `<p>${this.form.message}</p>`

        return {
          title: this.form.title,
          email: this.$store.state.user.email,
          memberId: this.$store.state.user.uuid,
          phoneNumber: this.$store.state.user.telNo,
          fullName: this.form.name,
          data: JSON.stringify(data),
          ref_obj_id: this.product.id,
          ref_obj_type: 'product'
        }
      },

      registerComplete () {
        this.cancelRegisterForm()
        this.submit()
      },

      submit () {
        if (this.$store.state.user) {
          this.submitPage()
        } else {
          this.showRegisterForm = true
          this.step = 2
        }
      },

      submitPage () {
        if (this.submitting) {
          return
        }
        this.submitting = true
        this.$modal.show({
          title: 'โปรดรอสักครู่',
          text: 'กำลังสร้างเพจ...',
          okButton: false
        })

        this.validateProduct().then(() => {
          this.createPage()
        }).catch(err => {
          console.log(err)
          this.showErrorMessage(err, true)
          this.submitting = false
        })
      },

      validateProduct () {
        if (!this.product) {
          return Promise.reject('ไม่พบการบริจาค')
        }

        return this.$http.get(`products/${this.$route.params.sku}`).then(resp => {
          if (resp.body.status) {
            return resp
          } else {
            return Promise.reject('ไม่พบการบริจาค')
          }
        })
      },

      createPage () {
        const payload = this.getPayload()

        this.$refs.card.captureCanvasToS3().then(result => {
          payload.image = result.image.split('?')[0]
          payload.share_image = result.shareImage.split('?')[0]

          payload.data = JSON.parse(payload.data)
          payload.data.top_image = result.topImage.split('?')[0]
          payload.data.bottom_image = result.bottomImage
          const emails = {}
          payload.data.send_ecard_emails.forEach(email => {
            emails[email.trim()] = true
          })
          payload.data.send_ecard_emails = Object.keys(emails)
          payload.data = JSON.stringify(payload.data)

          this.$http.post('pages', payload, { autoLogout: false }).then(resp => {
            this.$modal.hide()
            this.$router.push(`/pages/${resp.body.id}`)
          }).catch(resp => {
            this.submitting = false
            if (resp.status === 401) {
              this.$store.dispatch('logout')
              this.showRegisterForm = true
              this.$modal.hide()
            } else {
              this.$modal.show({
                title: 'เกิดข้อผิดพลาด',
                text: 'ไม่สามารถสร้างเพจได้ กรุณาลองใหม่อีกครั้ง'
              })
            }
          })
        })
      },

      cancelRegisterForm () {
        this.showRegisterForm = false
        this.step = 1
      }
    },

    watch: {
      'form.type': function () {
        this.$nextTick(() => {
          this.$refs.card.updateBottomImage()
          this.$refs.card.preloadImage('bottomImageSrc', 'bottomImageData')
        })
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// create.vue?8dac04cc